export const STANDARD_EDITOR_LIMIT_BYTES = 5 * 1024 * 1024;
